export const TERMS = `
<h1 style="margin-bottom: 0.11in; line-height: 108%">Pravila
nagradnog natječaja „POKAŽI BRZINU I OSVOJI 500 KUNA NA
VISA POKLON KARTICI!“</h1>

<br/>
<br/>

<h1 style="margin-bottom: 0.11in; line-height: 108%"><b>ČLANAK 1:
ORGANIZATOR </b>
</h1>
<p style="margin-bottom: 0.11in; line-height: 108%">Nagradni natječaj
priređuje i organizira: Zagrebačka banka d.d., Zagreb, Trg bana
Josipa Jelačića 10, OIB 92963223473 (u daljnjem tekstu:
Organizator).</p>
<br/>
<br/>
<h1 style="margin-bottom: 0.11in; line-height: 108%"><b>ČLANAK 2:
TRAJANJE, SVRHA I MJESTA PROVEDBE NAGRADNOG NATJEČAJA </b>
</h1>
<p style="margin-bottom: 0.11in; line-height: 108%">Natječaj se
provodi sa svrhom promocije Organizatora. Predviđeno razdoblje
trajanja nagradnog natječaja je od 13. do 27. srpnja 2017. u 23.59
sati, a odnosi se na cijelo područje Republike Hrvatske. 
</p>
<p style="margin-bottom: 0.11in; line-height: 108%">Organizator
zadržava pravo izmjene ukupnog trajanja Natječaja i datuma
proglašenja dobitnika. 
</p>
<br/>
<br/>
<h1 style="margin-bottom: 0.11in; line-height: 108%"><b>ČLANAK 3:
OBJAVA PRAVILA NAGRADNOG NATJEČAJA </b>
</h1>
<p style="margin-bottom: 0.11in; line-height: 108%">Pravila Natječaja
bit će objavljena na web stranici Zagrebačke banke www.tkokaze.hr
na sljedećem linku:
https://www.tkokaze.hr/pogodnosti/pokazi-brzinu-i-osvoji-500-kuna-na-visa-poklon-kartici
</p>
<br/>
<br/>
<h1 style="margin-bottom: 0.11in; line-height: 108%"><b>ČLANAK 4:
PRAVO SUDJELOVANJA </b>
</h1>
<p style="margin-bottom: 0.11in; line-height: 108%">Pravo
sudjelovanja u Natječaju imaju sve fizičke osobe s prebivalištem u
Republici Hrvatskoj: 
</p>
<ul>
	<li/>
<p style="margin-bottom: 0.11in; line-height: 108%">koje
	prihvaćaju ova Pravila 
	</p>
	<li/>
<p style="margin-bottom: 0.11in; line-height: 108%">koje su
	ispunile podatke pravim imenom i prezimenom koje odgovara imenu na
	osobnoj iskaznici 
	</p>
	<li/>
<p style="margin-bottom: 0.11in; line-height: 108%">koje su na
	interaktivnom ekranu Zagrebačke banke, postavljenom na Trgu bana
	Jelačića, Cvjetnom trgu i Zrinjevcu, u najbržem vremenu sparile 6
	parova u igrici memory</p>
</ul>
<p style="margin-bottom: 0.11in; line-height: 108%">Jedan sudionik
može odigrati igru više puta, ali se prijaviti može samo jedanput.
</p>
<p style="margin-bottom: 0.11in; line-height: 108%">Svaka upotreba
lažnih ili dvostrukih profila ili opravdana sumnja u njihovo
postojanje sankcionirat će se eliminacijom sudionika iz Natječaja. 
</p>
<p style="margin-bottom: 0.11in; line-height: 108%">U Natječaju ne
mogu sudjelovati osobe koje su izravno uključene u njegovu pripremu.
</p>
<p style="margin-bottom: 0.11in; line-height: 108%">Organizator
zadržava pravo u bilo kojem trenutku diskvalificirati prijavljene
sudionike u slučaju da: 
</p>
<p style="margin-bottom: 0.11in; line-height: 108%">a) sudionik
prekrši navedena pravila; 
</p>
<p style="margin-bottom: 0.11in; line-height: 108%">b) sudionik je
koristio lažne osobne podatke za sudjelovanje u Natječaju (provjeru
podataka vršit će Organizator). Do diskvalifikacije natjecatelja
može doći i ako se uvidom u podatke o aktivnostima u natječaju
utvrde bilo kakve nepravilnosti koje utječu na ravnopravno
sudjelovanje. 
</p>
<p style="margin-bottom: 0.11in; line-height: 108%">Diskvalificirani
sudionici bit će obaviješteni o svojoj diskvalifikaciji putem
obavijesti na svojim e-adresama. 
</p>
<br/>
<br/>
<h1 style="margin-bottom: 0.11in; line-height: 108%"><b>ČLANAK 5:
KAKO SUDJELOVATI </b>
</h1>
<p style="margin-bottom: 0.11in; line-height: 108%">Za sudjelovanje u
Natječaju potrebno je, na interaktivnom ekranu Zagrebačke banke,
postavljenom na Trgu bana Jelačića, Cvjetnom trgu i Zrinjevcu u
Zagrebu, u najbržem vremenu spariti 6 parova u igrici memory, kako
je navedeno na linku:
https://www.tkokaze.hr/pogodnosti/pokazi-brzinu-i-osvoji-500-kuna-na-visa-poklon-kartici</p>
<p style="margin-bottom: 0.11in; line-height: 108%">
Stručni žiri, sastavljen od predstavnika Zagrebačke banke, među
prijavljenim radovima koji su sukladni Pravilima Natječaja, odabrat
će i nagraditi 5 natjecatelja s najbržim vremenom. 
</p>
<p style="margin-bottom: 0.11in; line-height: 108%">Svaki pojedini
sudionik Natječaja može se prijaviti jedanput. 
</p>
<p style="margin-bottom: 0.11in; line-height: 108%">Prijavljeni rad
ne smije biti uvredljiv, niti neprikladan ili vulgaran sadržaj.</p>
<p style="margin-bottom: 0.11in; line-height: 108%">Sudionik može
biti diskvalificiran iz daljnjeg natjecanja ako se ne pridržava
Pravila ovog Natječaja. 
</p>
<br/>
<br/>
<h1 style="margin-bottom: 0.11in; line-height: 108%"><b>ČLANAK 6:
PROGLAŠENJE DOBITNIKA </b>
</h1>
<p style="margin-bottom: 0.11in; line-height: 108%">Imena dobitnika
glavne nagrade u Natječaju bit će objavljena u 31. srpnja na web
stranici Zagrebačke banke http://www.tkokaze.hr/.
</p>
<br/>
<br/>
<h1 style="margin-bottom: 0.11in; line-height: 108%"><b>ČLANAK 7:
FOND NAGRADA KOJI UTVRĐUJE ORGANIZATOR </b>
</h1>
<p style="margin-bottom: 0.11in; line-height: 108%">Glavna nagrada:
5x 500 kuna na Visa poklon kartici</p>
<p style="margin-bottom: 0.11in; line-height: 108%">Nagrada se ne
može zamijeniti za novac, drugu robu ili drugu uslugu. 
</p>
<br/>
<br/>
<h1 style="margin-bottom: 0.11in; line-height: 108%"><b>ČLANAK 8:
KAKO PREUZETI NAGRADU </b>
</h1>
<p style="margin-bottom: 0.11in; line-height: 108%">Dobitnici nagrada
bit će obaviješteni o svim detaljima o preuzimanju nagrade putem
e-adrese i broja telefona koje su upisali prilikom igranja memory
igrice na Zabinom interaktivnom ekranu. 
</p>
<p style="margin-bottom: 0.11in; line-height: 108%">Ako se dobitnik
glavne nagrade ne javi do 30. srpnja 2017. godine u 16.00 sati,
nagrada će se uručiti prvom idućem natjecatelju prema odluci
stručnog žirija. 
</p>
<p style="margin-bottom: 0.11in; line-height: 108%">Kod preuzimanja
nagrade dobitnici su obvezni potvrditi svoj identitet osobnom
iskaznicom i potpisati izjavu o njezinu primitku. 
</p>
<br/>
<br/>
<h1 style="margin-bottom: 0.11in; line-height: 108%"><b>ČLANAK 9:
SUDIONICI U NAGRADNOM NATJEČAJU </b>
</h1>
<p style="margin-bottom: 0.11in; line-height: 108%">Sudionici koji
sudjeluju u Natječaju ne mogu zahtijevati nagrade u većim
količinama ili drukčije nagrade od onih koje su navedene u ovim
Pravilima od Organizatora. Sudjelovanjem u ovom Natječaju sudionici
prihvaćaju prava i obveze iz ovih Pravila. 
</p>
<br/>
<br/>
<h1 style="margin-bottom: 0.11in; line-height: 108%"><b>ČLANAK 10:
PUBLICITET </b>
</h1>
<p style="margin-bottom: 0.11in; line-height: 108%">Sudjelovanjem u
ovom Natječaju sudionici prihvaćaju ova pravila te su suglasni da
se, postanu li dobitnici nagrade, njihovo ime i slika mogu javno
objaviti i bez naknade upotrebljavati od Organizatora u tiskanom,
zvučnom, slikovnom i/ili videomaterijalu, a za marketinške potrebe
Organizatora. 
</p>
<p style="margin-bottom: 0.11in; line-height: 108%">Sudjelovanjem u
Natječaju sudionik daje svoju izričitu privolu Organizatoru da
prikuplja, obrađuje i upotrebljava njegove osobne podatke (ime,
prezime, datum i godinu rođenja, e-adresu, fotografiju, broj
telefona) za potrebe provedbe natječaja. 
</p>
<br/>
<br/>
<h1 style="margin-bottom: 0.11in; line-height: 108%"><b>ČLANAK 11:
POREZI </b>
</h1>
<p style="margin-bottom: 0.11in; line-height: 108%">Dobitnik ne snosi
nikakve poreze, obveze ni naknade izravno povezane s nagradama. 
</p>
<br/>
<br/>
<h1 style="margin-bottom: 0.11in; line-height: 108%"><b>ČLANAK 12: U
SLUČAJU SPORA </b>
</h1>
<p style="margin-bottom: 0.11in; line-height: 108%">U slučaju spora
između Organizatora i sudionika Natječaja mjerodavan je Općinski
građanski sud u Zagrebu. 
</p>
<br/>
<br/>
<h1 style="margin-bottom: 0.11in; line-height: 108%"><b>ČLANAK 13:
PRESTANAK OBVEZA </b>
</h1>
<p style="margin-bottom: 0.11in; line-height: 108%">Preuzimanjem
nagrade prestaju sve obveze priređivača Natječaja prema dobitniku.
</p>
<br/>
<br/>
<h1 style="margin-bottom: 0.11in; line-height: 108%"><b>ČLANAK 14:
MOGUĆNOST PREKIDA NAGRADNOG NATJECANJA </b>
</h1>
<p style="margin-bottom: 0.11in; line-height: 108%">Natječaj se može
prekinuti samo u slučaju nastanka okolnosti za koje Organizator nije
odgovoran, odnosno koje nije mogao spriječiti, otkloniti ili
izbjeći. Sudionici će o eventualnom prekidu nagradnog natječaja
biti obaviješteni putem službene Facebook stranice Zagrebačke
banke: https://www.facebook.com/ZagrebackaBanka
i na web stranici Zagrebačke banke http://www.tkokaze.hr.
</p>
<br/>
<br/>
<h1 style="margin-bottom: 0.11in; line-height: 108%"><b>ČLANAK 15:
IZMJENA PRAVILA </b>
</h1>
<p style="margin-bottom: 0.11in; line-height: 108%">Organizator
zadržava pravo na izmjenu pravila ovog Natječaja u slučaju
nastanka okolnosti iz članka 14. ovih Pravila, a o čemu će
sudionici biti obaviješteni kako je to navedeno u istom članku 14.</p>`




// WEBPACK FOOTER //
// ./src/terms.js